export default __webpack_public_path__ + "static/flower-top-big-e520a110fbcffbb546a2700adb47fc78.png";